var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Header'),_c('div',{staticClass:"landing"},[_c('div',{staticClass:"landing-content"},[_c('router-view')],1),_c('Hotline'),_c('Call')],1),_c('Footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }